import { GameState } from './game';
import { LeagueType } from './league';

// multiplier for points in a tournament depending on the league
export const GLOBALTOPLIST_TOURNAMENT_POINTS_MULTIPLIER = {
  [LeagueType.Bronze]: 0.25,
  [LeagueType.Silver]: 0.5,
  [LeagueType.Gold]: 1,
};

export interface Tournament {
  tournamentId: string;
  name: string;
  description: string;
  horsesTotalAmount: number;
  horsesPerPlayerAmount: number;
  startingTimes: string[]; // array of timestamps when this tournament will start (ISO 8601: YYYY-MM-DDTHH:mm:ss.sssZ)
  lobbyOpenTimeDiff: number; // time diff in seconds before each timestamp from startingTimes when the lobby opens
  tournamentLeague: LeagueType;
  isFinished: boolean;
  games?: GameState[];
}

export interface TournamentOverview {
  tournamentId: string;
  name: string;
  description: string;
  horsesTotalAmount: number;
  horsesPerPlayerAmount: number;
  startingTimes: string[]; // array of timestamps when this tournament will start (ISO 8601: YYYY-MM-DDTHH:mm:ss.sssZ)
  lobbyOpenTimeDiff: number; // time diff in seconds before each timestamp from startingTimes when the lobby opens
  tournamentLeague: LeagueType;
  isFinished: boolean;
  amountPlayersJoined: number;
  /** Player counts aligned by index to `startingTimes` (historic + upcoming timeslots). */
  amountPlayersJoinedPerStartingTime?: number[];
  allowedUserHorseIds: string[]; // array of horseIds from the requesting user that are allowed to join this tournament
}

export interface TournamentRequest {
  name: string;
  description: string;
  horsesTotalAmount?: number;
  horsesPerPlayerAmount?: number;
  startingTimes: string[];
  lobbyOpenTimeDiff: number;
  tournamentLeague: LeagueType;
}

// result of a tournament for a single user (i.e., one for each user in the tournament)
export interface TournamentResult {
  tournamentId: string;
  tournamentLeague: LeagueType;
  userId: string;
  pointsRaw: number; // points without any multiplier for league
  timeFinished: string; // ISO 8601: YYYY-MM-DDTHH:mm:ss.sssZ
}
